module.exports = __webpack_public_path__ + "static/media/9@1024w.eac9f50a.jpg";